export const TRIGGERED_BROADCASTS_TABLE_SORT_OPTIONS = [
  {
    label: 'Sent emails',
    value: 'sent',
  },
  {
    label: 'Name',
    value: 'name',
  },
  {
    label: 'Created',
    value: 'created',
  },
  {
    label: 'Edited',
    value: 'updated',
  },
];

export const CAMPAIGN_MODEL_SORT_OPTIONS = [
  {
    label: 'Name',
    value: 'name',
  },
  {
    label: 'Created',
    value: 'created',
  },
  {
    label: 'Edited',
    value: 'updated',
  },
];

export const CAMPAIGN_METRIC_SORT_OPTIONS = [
  {
    label: 'Sent',
    value: 'sent',
  },
  {
    label: 'Delivered',
    value: 'delivered',
  },
  {
    label: 'Opened',
    value: 'opened',
  },
  {
    label: 'Clicked',
    value: 'clicked',
  },
  {
    label: 'Attempted',
    value: 'attempted',
  },
  {
    label: 'Converted',
    value: 'converted',
  },
  {
    label: 'Bounced',
    value: 'bounced',
  },
  {
    label: 'Failed',
    value: 'failed',
  },
  {
    label: 'Spammed',
    value: 'spammed',
  },
  {
    label: 'Undeliverable',
    value: 'undeliverable',
  },
  {
    label: 'Unsubscribed',
    value: 'unsubscribed',
  },
  {
    label: 'Unsubscribed from topics',
    value: 'topic_unsubscribed',
  },
];

export const CAMPAIGN_SORT_OPTIONS = [...CAMPAIGN_MODEL_SORT_OPTIONS, ...CAMPAIGN_METRIC_SORT_OPTIONS];
